import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	InputAdornment, SvgIcon,
	TextField, Divider
} from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import TableContainer from "@material-ui/core/TableContainer";
import React from 'react';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import Tooltip from '@material-ui/core/Tooltip'
import { Search as SearchIcon } from 'react-feather';
import Fuse from 'fuse.js'
import { useActions, useValues } from 'kea';

import grouplogic from 'src/store/group';

import AddDialog from './AddDialog';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});


const columns = [
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 200,
	},
	{
		field: 'actions',
		align: 'right',
		headerName: 'Actions',
		width: 100,
	},
];

const options = {
	includeScore: false,
	keys: [
		'job_title',
		'title',
		'first_name',
		'last_name',
	]
}

const Users = ({ users, selectedGroup }) => {
	const classes = useStyles();

	const { add_users, remove_users } = useActions(grouplogic);

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	// const [data, setData] = React.useState(rows);
	let rows = users;
	let emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	const [searchField, setSearchField] = React.useState('');
	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleRemove = (id) => {
		remove_users({
			_id: selectedGroup._id,
			users: [id]
		})
	}

	const onHandleAdd = (new_users) => {
		add_users({
			_id: selectedGroup._id,
			users: new_users
		})
	}

	if (searchField) {
		const fuse = new Fuse(rows, options);
		rows = fuse.search(searchField).map(item => {
			return item.item;
		})
		emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
	}

	return (
		<Card
			className={classes.root}
		>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<div style={{
					display: 'flex',
					flexGrow: '1',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '10px 15px 5px 15px'
				}}>
					<Typography variant="h4">
						Users
					</Typography>
					<TextField
						width={400}
						size={'small'}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon
										fontSize="small"
										color="action"
									>
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							)
						}}
						onChange={e => setSearchField(e.target.value)}
						placeholder="Search ..."
						variant="outlined"
					/>
					<div style={{
						width: '70px',
						paddingLeft: '5px'
					}}>
						<AddDialog exclude={users} onHandleAdd={onHandleAdd} />
					</div>
				</div>
				<Divider />
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										align={column.align}
										style={{ minWidth: column.width }}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								rows && rows.length > 0 ?
									rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											return (
												<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
													{columns.map((column) => {
														if (column.field === 'name') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		{`${row.job_title} - ${row.title} ${row.first_name} ${row.last_name}`}
																	</TableCell>
																</>
															)
														}
														if (column.field === 'actions') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		<Tooltip title='Remove User'>
																			<IconButton aria-label="delete" onClick={() => handleRemove(row._id)}>
																				<RemoveIcon color="secondary" />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																</>
															)
														}
														const value = row[column.field];
														return (
															<TableCell key={column.field} align={column.align}>
																{column.format && typeof value === "number"
																	? column.format(value)
																	: value}
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <TableRow>
										<TableCell style={{ height: 61 * rowsPerPage }} colSpan={3} align={'center'}>
											No Users Assigned
										</TableCell>
									</TableRow>
							}
							{
								rows.length > 0 && emptyRows > 0 && (
									<TableRow style={{ height: 61 * emptyRows }}>
										<TableCell colSpan={6} />
									</TableRow>
								)
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				{/* </Paper> */}
			</div>
		</Card>
	);
};


export default Users;
